import React from "react";
import { getColors, getClassConditionalAppend, getContainerClassPerMaxWidth, } from "../../utils";
import { CardWithImageAndGradient, } from "./CardWithImageAndGradient/CardWithImageAndGradient";
import { ContainerFW, Container } from "../global";
export const M31FiveCardsTitleText = ({ cards, subTitle, title, backgroundColor, titleAlignment, subTitleAlignment, titleColor = "0E1D31", subTitleColor = "#3E4A5A", containerMaxWidth, cardContentAlignment, styleVariant = "default", }) => {
    const { bgColor } = getColors(backgroundColor);
    const containerMaxWidthClass = getContainerClassPerMaxWidth(containerMaxWidth);
    const containerExtraClass = getClassConditionalAppend(containerMaxWidthClass);
    const extraRootCSSClass = (() => {
        let extraCSSClass = "";
        if (styleVariant === "ladder-like") {
            extraCSSClass += " five-cards-title-text-root--ladder-style";
        }
        return extraCSSClass;
    })();
    const customRootTitleStyleObj = (() => ({
        "--title-alignment_small-view": titleAlignment?.["small-view"] || "start",
        "--title-alignment_medium-view": titleAlignment?.["medium-view"] || "start",
        "--title-alignment_large-view": titleAlignment?.["large-view"] || "start",
        "--title-text-color": titleColor,
    }))();
    const customRootSubTitleStyleObj = (() => ({
        "--subTitle-alignment_small-view": subTitleAlignment?.["small-view"] || "start",
        "--subTitle-alignment_medium-view": subTitleAlignment?.["medium-view"] || "start",
        "--subTitle-alignment_large-view": subTitleAlignment?.["large-view"] || "start",
        "--subTitle-text-color": subTitleColor,
    }))();
    const customCardDeckStyle = (() => ({
        "--card-content-alignment_small-view": cardContentAlignment?.["small-view"] || "start",
        "--card-content-alignment_medium-view": cardContentAlignment?.["medium-view"] || "start",
        "--card-content-alignment_large-view": cardContentAlignment?.["large-view"] || "start",
        "--container-background-color": bgColor,
    }))();
    return (React.createElement("div", { className: `five-cards-title-text-root ${extraRootCSSClass}` },
        React.createElement(ContainerFW, { className: containerExtraClass, backgroundColor: bgColor },
            React.createElement(Container, { className: containerExtraClass },
                React.createElement("div", { className: "five-cards-title-text-root__textWrapper" },
                    React.createElement("div", { className: "h3-semi-bold", dangerouslySetInnerHTML: {
                            __html: title || "",
                        }, style: customRootTitleStyleObj }),
                    React.createElement("div", { className: "p-regular", style: customRootSubTitleStyleObj, dangerouslySetInnerHTML: {
                            __html: subTitle || "",
                        } })),
                React.createElement("div", { className: "five-cards-title-text-root__cardsWrapper", style: customCardDeckStyle }, Array.isArray(cards) &&
                    cards.map((card) => (React.createElement(CardWithImageAndGradient, { key: `unique${card.title}`, ...card, containerBackgroundColor: bgColor }))))))));
};
